document.addEventListener('DOMContentLoaded', () => {
  const quickAddBtns = document.querySelectorAll('.quick-add-btn');
  const cartCount = document.querySelector('.cart-count');
  let count = 0;

  quickAddBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      count++;
      if (cartCount) cartCount.textContent = count;
      btn.textContent = 'Added! ✓';
      btn.style.backgroundColor = '#e2b13c';
      btn.style.color = '#000';
      
      setTimeout(() => {
        btn.textContent = 'Quick Add';
        btn.style.backgroundColor = 'transparent';
        btn.style.color = '#fff';
      }, 1500);
    });
  });
});
